export const scene7ImageLoader = ({
  src,
  width
}: {
  src: string;
  width: number;
}) => {
  const imageUrl = new URL(src);

  // Calculate the respective height for given width to preserve the aspect-ratio
  const currentWidth = imageUrl.searchParams.get('wid');
  const currentHeight = imageUrl.searchParams.get('hei');
  if (currentHeight && currentWidth) {
    const currentAspectRatio = parseInt(currentHeight) / parseInt(currentWidth);
    const height = parseInt(`${width * currentAspectRatio}`);
    imageUrl.searchParams.set('hei', height.toString());
  }

  // Set Width from nextjs image
  imageUrl.searchParams.set('wid', width.toString());
  // Sorts search params to suppress warning from next. If the src input to the loader
  // is the same src that comes out, it assumes the there was no optimization done
  imageUrl.searchParams.sort();

  // Return processed Image Url
  return imageUrl.href;
};
